import type { ListTotal } from '../../api/client';
import { formatDecimal, type FieldSummary } from '../format';

/** Totaux de liste (ADR-095) : pied de liste et en-têtes de groupe (ADR-099) les formatent de même. */

export const AGGREGATION_LABELS: Readonly<Record<ListTotal['aggregation'], string>> = { sum: 'Total', avg: 'Moyenne', min: 'Minimum', max: 'Maximum', count: 'Nombre' };

/**
 * Sous-totaux d'un total, un par devise ou unité, formatés depuis leur chaîne décimale sans passer
 * par `number` (R2). Une devise ISO se formate en monnaie ; une autre unité suit le nombre.
 */
export function formatTotal(total: ListTotal, field: FieldSummary | undefined): string | string[] {
  if (total.values.length === 0) return '—';
  const one = (entry: ListTotal['values'][number]): string => {
    if (entry.unit !== undefined && /^[A-Z]{3}$/.test(entry.unit) && field?.type !== 'quantity') return formatDecimal(entry.value, 'fr', { style: 'currency', currency: entry.unit });
    const number = formatDecimal(entry.value, 'fr', { maximumFractionDigits: 3 });
    return entry.unit === undefined ? number : `${number} ${entry.unit}`;
  };
  return total.values.length === 1 ? one(total.values[0]!) : total.values.map(one);
}

